export default __webpack_public_path__ + "static/media/thum_7.d496c2d6.png";